import { useContext, useEffect, useState } from 'react';
import useErrorReporter from 'web/hooks/useErrorReporter';
import FirebaseContext from './FirebaseContext';

const lazyFirestore: { [appName: string]: typeof import('./getFirestore') } = {};

const useFirestoreLazy = ({ enabled = true, preload = false }: { enabled?: boolean; preload?: boolean } = {}) => {
  const firebase = useContext(FirebaseContext);
  const errorReporter = useErrorReporter();
  const [firestore, setFirestore] = useState(lazyFirestore[firebase.name]);
  useEffect(() => {
    if ((enabled || preload) && !firestore) {
      import('./getFirestore')
        .then((exports) => {
          lazyFirestore[firebase.name] = exports;
          setFirestore(exports);
        })
        .catch((error) => errorReporter.report(error));
    }
  }, [enabled, firebase.name, firestore, preload, errorReporter]);
  return firestore;
};

export default useFirestoreLazy;
